declare global {
    interface Window {
        gtag?: (...args: any[]) => void;
    }
}

type Params = Record<string, any>;

export function trackEvent(name: string, params: Params = {}) {
    if (!window.gtag) return;

    window.gtag("event", name, {
        app: "dashboard",
        iframe: window.parent !== window,
        // debug_mode: true, // Uncomment when testing local DebugView for custom events
        ...params,
    });
}

export function trackPageView(path: string) {
    if (!window.gtag) return;

    window.gtag("event", "page_view", {
        page_path: path,
        page_location: window.location.href,
        iframe: window.parent !== window,
    });
}